import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppSettingService } from '../services/app-setting.service';
import { LoginInfoService } from '../services/login-info.service';

@Directive({
  selector: '[kperm]'
})
export class KpermDirective implements OnInit {

  @Input('kperm') permKeyCode: string;
  constructor(private el: ElementRef,
    private appsettingService: AppSettingService,
    private loginService: LoginInfoService,
    private activeRouter: ActivatedRoute) { }

  ngOnInit() {
    if (this.appsettingService.getLocalDebug()) {
      return
    }
    let keycode = this.loginService.getKeyCodeByPageUrl(this.appsettingService.getPrintUrl() + this.activeRouter.snapshot['_routerState'].url);
    if (this.loginService.getLoginInfo().userId == -1) {
      return;
    }
    if (!this.loginService.checkPerm(`${keycode}.${encodeURIComponent(this.permKeyCode)}`)) {
      // this.el.nativeElement.style.display = 'none';  //没有权限将控件隐藏
    }
  }
}
